import React from 'react';

export default function NotMatch() {
  return (
    <div>No page found</div>
  );
}
